import {
	PINReaders_TYPE_REQUEST,
	PINReaders_TYPE_SUCCESS,
	PINReaders_TYPE_FAILURE,
	PINReaders_UPDATE_REQUEST,
	PINReaders_UPDATE_SUCCESS,
	PINReaders_UPDATE_FAILURE,
	PINReaders_UPDATE_RESET,
} from "./pinConstants";

export const pINReadersReducer = (
	initialState = {
		pINReaderss: [],
	},
	action
) => {
	switch (action.type) {
		case PINReaders_TYPE_REQUEST:
			return {
				...initialState,
				loading: true,
				pINReaderss: [],
			};
		case PINReaders_TYPE_SUCCESS:
			return {
				...initialState,
				data: action.payload,
				loading: false,
			};

		case PINReaders_TYPE_FAILURE:
			return {
				...initialState,
				loading: false,
				getError: action.payload,
			};
		//pINReaders Update
		case PINReaders_UPDATE_REQUEST:
			return { ...initialState, updateLoading: true };
		case PINReaders_UPDATE_SUCCESS:
			return {
				...initialState,
				updateLoading: false,
				updateSuccess: true,
			};
		case PINReaders_UPDATE_FAILURE:
			return {
				...initialState,
				updateLoading: false,
				updateError: action.payload,
			};
		case PINReaders_UPDATE_RESET:
			return { ...initialState,pINReaders: {} };
		default:
			return initialState;
	}
};
